import { render } from "./KeywordIdeas.vue?vue&type=template&id=4d635aa1&scoped=true"
import script from "./KeywordIdeas.vue?vue&type=script&lang=js"
export * from "./KeywordIdeas.vue?vue&type=script&lang=js"

import "./KeywordIdeas.vue?vue&type=style&index=0&id=4d635aa1&lang=scss&scoped=true"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d635aa1"]])

export default __exports__